// extracted by mini-css-extract-plugin
export default {"note":"NoteCellRenderer_note__XPq+9","noNote":"NoteCellRenderer_noNote__SP3Pc"};